import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: '297b1d7d-e083-4e72-97bc-4017892b1b12'
            /* ...Other Configuration Options... */
    }
});
appInsights.loadAppInsights();
appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
